import { checkActiveCustomer } from "@src/api/customerCheck";
import { useQuery } from "react-query";

function useCheckActiveCustomer() {
  return useQuery(['activeCustomer'], () => checkActiveCustomer(), {
    refetchOnWindowFocus: "always",
    retry: false,
  });
}

export default useCheckActiveCustomer;
